import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../lib/store';
import { setUseDemoAccount } from '../lib/store/crm';
import { hasAccountPaidAndDemoPlan } from '../lib/store/crm/helpers';
import { CRMCall } from '../lib/store/crm/types';
import { isCallStatusReady } from '../lib/util/error-handling/StatusByCallHelpers';

const SESSION_KEY = 'isSolanaPendingPlanPayment';
const CHANGE_EVENT = 'solanaPendingPlanPaymentChange';

export const setSolanaPendingPlanPayment = (value: boolean) => {
  if (value) {
    sessionStorage.setItem(SESSION_KEY, 'true');
  } else {
    sessionStorage.removeItem(SESSION_KEY);
  }
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

const useSolanaPendingPlanPayment = () => {
  const dispatch = useDispatch();
  const hasPaidAndDemoPlan = useSelector((state: RootState) => hasAccountPaidAndDemoPlan(state.crm));
  const isUseDemoAccount = useSelector((state: RootState) => state.crm.isUseDemoAccount);
  const isAccountsReady = useSelector((state: RootState) =>
    isCallStatusReady(CRMCall.getAccounts, state.crm.statusByCall));

  const [isSolanaPendingPlanPayment, setIsSolanaPendingPlanPayment] = useState(
    () => sessionStorage.getItem(SESSION_KEY) === 'true',
  );

  useEffect(() => {
    const isPending = sessionStorage.getItem(SESSION_KEY) === 'true';
    if (isUseDemoAccount) {
      if (isPending && hasPaidAndDemoPlan) {
        dispatch(setUseDemoAccount(false));
        sessionStorage.removeItem(SESSION_KEY);
        setIsSolanaPendingPlanPayment(false);
      }
    } else if (isPending && isAccountsReady) {
      sessionStorage.removeItem(SESSION_KEY);
      setIsSolanaPendingPlanPayment(false);
    }
  }, [hasPaidAndDemoPlan, isAccountsReady, isUseDemoAccount]);

  useEffect(() => {
    const handleChange = () => {
      setIsSolanaPendingPlanPayment(sessionStorage.getItem(SESSION_KEY) === 'true');
    };

    window.addEventListener(CHANGE_EVENT, handleChange);
    return () => window.removeEventListener(CHANGE_EVENT, handleChange);
  }, []);

  return isSolanaPendingPlanPayment;
};

export default useSolanaPendingPlanPayment;
